"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const assembler_1 = require("./assembler");
const errors_1 = require("./errors");
const utils_1 = require("./utils");
const semantic_json_1 = require("@hediet/semantic-json");
const schema_1 = require("./schema");
const result_1 = require("@hediet/semantic-json/dist/src/result");
class NamedCmdArg {
    constructor(name, type, description, shortName, excludeFromSchema) {
        this.name = name;
        this.type = type;
        this.description = description;
        this.shortName = shortName;
        this.excludeFromSchema = excludeFromSchema;
    }
    get isOptional() {
        return this.type.kind === "TypeWithDefaultValue";
    }
}
exports.NamedCmdArg = NamedCmdArg;
class Cmd {
    constructor(name, description, positionalArgs, namedArgs, dataBuilder) {
        this.name = name;
        this.description = description;
        this.positionalArgs = positionalArgs;
        this.namedArgs = namedArgs;
        this.dataBuilder = dataBuilder;
    }
    parseArgs(cmd) {
        function expectType(item) {
            return item;
        }
        const namedArgs = utils_1.mapObject(this.namedArgs, val => expectType({
            kind: val.type.kind === "TypeWithDefaultValue"
                ? val.type.type.kind
                : val.type.kind,
            shortName: val.shortName,
        }));
        const assembler = new assembler_1.CmdAssembler({
            namedArgs,
        });
        const errors = new errors_1.ErrorsImpl();
        const asm = assembler.process(cmd);
        errors.addFrom(asm.errors);
        const parsedArgs = {};
        for (const [key, argInfo] of Object.entries(this.namedArgs)) {
            const argVal = asm.namedArgs[key];
            let parsed;
            if (argVal) {
                parsed = argInfo.type.getRealType().parseStrings(argVal.values);
            }
            else if (argInfo.type.kind === "TypeWithDefaultValue") {
                parsed = { result: argInfo.type.defaultValue };
            }
            else {
                errors.addError({
                    kind: "MissingRequiredArgument",
                    argument: argInfo,
                    message: `Argument "${key}" has not been specified, but is required.`,
                });
                continue;
            }
            if ("result" in parsed) {
                parsedArgs[key] = parsed.result;
            }
            else {
                errors.addError(parsed.error);
            }
        }
        const positionalArgs = asm.positionalArgs.slice();
        for (const argInfo of this.positionalArgs) {
            let value;
            const realType = argInfo.type.getRealType();
            if (realType.kind === "SingleValue") {
                const arg = positionalArgs.shift();
                if (!arg) {
                    if (argInfo.type.kind === "TypeWithDefaultValue") {
                        value = { result: argInfo.type.defaultValue };
                    }
                    else {
                        errors.addError({
                            kind: "MissingPositionalValue",
                            argument: argInfo,
                            message: `Positional argument "${argInfo.name}" has not been specified, but is required.`,
                        });
                        continue;
                    }
                }
                else {
                    value = realType.parse(arg.value);
                }
            }
            else if (realType.kind === "MultiValue") {
                value = realType.parse(positionalArgs.map(a => a.value));
            }
            else {
                const n = realType;
                throw new Error();
            }
            if ("result" in value) {
                parsedArgs[argInfo.name] = value.result;
            }
            else {
                errors.addError(value.error);
            }
        }
        const dataBuilder = this.dataBuilder;
        const dataFactory = dataBuilder && !errors.hasErrors
            ? () => dataBuilder(parsedArgs)
            : undefined;
        return { parsedArgs, errors, dataFactory };
    }
    getSerializer() {
        return semantic_json_1.sObject({
            properties: {
                cmd: semantic_json_1.sLiteral(this.name || "main"),
                ...Object.fromEntries(this.positionalArgs.map(arg => [
                    arg.name,
                    semantic_json_1.field({
                        serializer: arg.type.serializer,
                        optional: false,
                        description: arg.description,
                    }),
                ])),
                ...Object.fromEntries(Object.entries(this.namedArgs)
                    .filter(([_, arg]) => !arg.excludeFromSchema)
                    .map(([name, arg]) => [
                    arg.name,
                    semantic_json_1.field({
                        serializer: arg.type.serializer,
                        optional: arg.isOptional,
                        description: arg.description,
                    }),
                ])),
            },
        })
            .refine({
            canSerialize: (i) => i instanceof schema_1.InstantiatedCmd,
            deserialize: i => {
                delete i.cmd;
                const dataBuilder = this.dataBuilder;
                if (!dataBuilder) {
                    throw new Error("No data builder set.");
                }
                return result_1.deserializationValue(new schema_1.InstantiatedCmd(() => dataBuilder(i)));
            },
            serialize: i => {
                throw new Error("Not supported!");
            },
        })
            .defineAs(schema_1.cliNs("cmd-" + (this.name || "main")));
    }
}
exports.Cmd = Cmd;
//# sourceMappingURL=cmd.js.map